module.exports = __webpack_public_path__ + "img/people.cdfabcb8.png";